import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { PaymentCheckoutWizardModule } from '@app/account/shared/payment-checkout-wizard/payment-checkout-wizard.module';
import { AlertModule } from '@core/components/alert/alert.module';
import { AuthorInfoComponent } from '@core/components/author-info/author-info.component';
import { BookmarkComponent } from '@core/components/bookmark/bookmark.component';
import { MobileModalModule } from '@core/components/mobile-modal/mobile-modal.module';
import { ModalModule } from '@core/components/modal/modal.module';
import { SubscribeComponent } from '@core/components/subscribe/subscribe.component';
import { CoreModule } from '@core/core.module';
import { TranslateModule } from '@ngx-translate/core';
import { ComplaintFormModule } from '@shared/complaint-form/complaint-form.module';
import { IconComponent } from '@shared/icon/icon.component';
import { RatingComponent } from '@shared/rating/rating.component';
import { PaymentFormCardSelectorModule, PaymentFormUniversalModule } from 'lingo2-forms';
import { DateFnsModule } from 'lingo2-ngx-date-fns';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import {
  OnUiButtonModule,
  OnUiCardMenuModule,
  OnUiCoverModule,
  OnUiPopoverModule,
  OnUiReceiptModule,
} from 'onclass-ui';
import { CollectionLicensePricesModule } from '../collection-license-prices/collection-license-prices.module';
import { CollectionMetaModule } from '../collection-meta/collection-meta.module';
import { CollectionCardMiniComponent } from './collection-card-mini.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule,
    LazyLoadImageModule,
    CollectionMetaModule,
    CollectionLicensePricesModule,
    IconComponent,
    OnUiCardMenuModule,
    AlertModule,
    ModalModule,
    MobileModalModule,
    ComplaintFormModule,
    DateFnsModule,
    CoreModule,
    PaymentFormUniversalModule,
    PaymentFormCardSelectorModule,
    OnUiReceiptModule,
    OnUiCoverModule,
    OnUiButtonModule,
    PaymentCheckoutWizardModule,
    OnUiPopoverModule,
    BookmarkComponent,
    SubscribeComponent,
    RatingComponent,
    AuthorInfoComponent,
  ],
  declarations: [CollectionCardMiniComponent],
  exports: [CollectionCardMiniComponent],
})
export class CollectionCardMiniModule {}
